import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getMenuItems } from "../../api/category/categoryApi";
import { getFirstMenuHomePath } from "../../utils/menuNavigation";
import { loadRequest } from "../../utils/loadRequest";
import { LoadingState, ErrorState } from "../status/StatusView";

const DashboardRedirect = () => {
  const history = useHistory();
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    window.scrollTo(0, 0);
    setFailed(false);
    const redirect = async () => {
      try {
        const { data } = await loadRequest(getMenuItems);
        if (!active) return;
        const path = getFirstMenuHomePath(data);
        if (!path) throw new Error("No navigation destination");
        history.replace(path);
      } catch (error) {
        if (active) setFailed(error);
      }
    };
    redirect();
    return () => {
      active = false;
    };
  }, [history, attempt]);

  return failed ? (
    <ErrorState
      size="section"
      error={failed}
      homeTo="/login"
      onRetry={() => setAttempt((value) => value + 1)}
    />
  ) : (
    <LoadingState size="section" />
  );
};

export default DashboardRedirect;
